export default class User implements IUser {

    id: string;
    name: string;
    isMetric?: boolean;
    timeZoneId?: string;
    securityGroups?: ISecurityGroup[];
    keys?: any[];
    featurePreview?: string;
    displayCurrency?: string;
    driverGroups?: IGroup[];
    companyGroups?: IGroup[];
    /** @deprecated Not a reliable way to get the latest HOS ruleset for a driver
     * Use hosProcess.getLatestHosRuleSetIdShortened() or userHosRuleSetService.getLatestHosRuleSetIdShortened()
    */
    hosRuleSet?: string;
    isPersonalConveyanceEnabled?: boolean;
    isYardMoveEnabled?: boolean;
    isAdverseDrivingEnabled?: boolean;
    isEmergencyResponseExemptionAllowed?: boolean;
    licenseProvince?: string;
    licenseNumber?: string;
    carrierNumber?: string;
    companyName?: string;
    companyAddress?: string;
    firstName?: string;
    lastName?: string;
    language?: string;
    authorityName?: string;
    authorityAddress?: string;
    userAuthenticationType?: string;
    dateFormat?: string;

    constructor(object?: any) {
        this.id = "";
        this.name = "";
        if (object) {
            this.id = object.id;
            this.name = object.name;
            this.isMetric = object.isMetric;
            this.timeZoneId = object.timeZoneId;
            this.securityGroups = object.securityGroups;
            this.keys = object.keys;
            this.driverGroups = object.driverGroups;
            this.companyGroups = object.companyGroups;
            this.featurePreview = object.featurePreview;
            this.displayCurrency = object.displayCurrency;
            this.hosRuleSet = object.hosRuleSet;
            this.isPersonalConveyanceEnabled = object.isPersonalConveyanceEnabled;
            this.isYardMoveEnabled = object.isYardMoveEnabled;
            this.isAdverseDrivingEnabled = object.isAdverseDrivingEnabled;
            this.isEmergencyResponseExemptionAllowed = object.isEmergencyResponseExemptionAllowed;
            this.licenseProvince = object.licenseProvince;
            this.licenseNumber = object.licenseNumber;
            this.carrierNumber = object.carrierNumber;
            this.companyName = object.companyName;
            this.companyAddress = object.companyAddress;
            this.firstName = object.firstName;
            this.lastName = object.lastName;
            this.language = object.language;
            this.authorityName = object.authorityName;
            this.authorityAddress = object.authorityAddress;
            this.userAuthenticationType = object.userAuthenticationType;
            this.dateFormat = object.dateFormat;
        }
    }

    getFullName() {
        let fullName = "";

        if (this.firstName) {
            fullName += this.firstName;
        }

        if (this.lastName) {
            fullName += (fullName.length > 0 ? " " : "") + this.lastName;
        }
        return fullName.length > 0 ? fullName : this.name;
    }

    getInitials() {
        let initials = "";

        if (this.firstName) {
            initials += this.firstName.charAt(0);
        }

        if (this.lastName) {
            initials += this.lastName.charAt(0);
        }

        if (initials.length === 0 && this.name) {
            // Fallback onto the first letter of the email address
            initials += this.name.charAt(0);
        }
        // to uppercase
        return initials.toUpperCase();
    }

    getUserColor() {
        let hash = 0;
        let name = `${ (this.name || "") }${ this.id }`;

        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + (((hash << 5) - hash));
        }

        let colour = "#";
        for (let i = 0; i < 3; i++) {
            let value = (hash >> (i * 8)) & 0xFF;
            colour += (`00${ value.toString(16) }`).substr(-2);
        }

        return colour;
    }
}